/* tslint:disable */
/* eslint-disable */
/**
 * CourierApi
 * CourierApi
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CourierPackageUpdatePackageStatusRequest
 */
export interface CourierPackageUpdatePackageStatusRequest {
    /**
     * 
     * @type {string}
     * @memberof CourierPackageUpdatePackageStatusRequest
     */
    ids?: string;
    /**
     * 
     * @type {string}
     * @memberof CourierPackageUpdatePackageStatusRequest
     */
    status?: string;
}

/**
 * Check if a given object implements the CourierPackageUpdatePackageStatusRequest interface.
 */
export function instanceOfCourierPackageUpdatePackageStatusRequest(value: object): value is CourierPackageUpdatePackageStatusRequest {
    return true;
}

export function CourierPackageUpdatePackageStatusRequestFromJSON(json: any): CourierPackageUpdatePackageStatusRequest {
    return CourierPackageUpdatePackageStatusRequestFromJSONTyped(json, false);
}

export function CourierPackageUpdatePackageStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourierPackageUpdatePackageStatusRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'] == null ? undefined : json['ids'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function CourierPackageUpdatePackageStatusRequestToJSON(json: any): CourierPackageUpdatePackageStatusRequest {
    return CourierPackageUpdatePackageStatusRequestToJSONTyped(json, false);
}

export function CourierPackageUpdatePackageStatusRequestToJSONTyped(value?: CourierPackageUpdatePackageStatusRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
        'status': value['status'],
    };
}

